var map = {
	"./1.png": 45321,
	"./2.png": 80178,
	"./20.png": 50376,
	"./21.png": 48241,
	"./3.png": 29179,
	"./4.png": 19236,
	"./5.png": 61741,
	"./6.png": 71062,
	"./7.png": 49151,
	"./8.png": 42600,
	"./9.png": 82545,
	"./kangkong-Kalmi Saag.png": 14901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58993;